export { externalLogInSchema } from '@workspace/auth/schemas';
export type { ExternalLogInSchema } from '@workspace/auth/schemas';
